import { Text } from "@swiggy-private/dls-web-core/dist/components/Text";
import styled, { DefaultTheme } from "styled-components";

export const BillDetailsSubWrapper = styled.div(({ theme }) => ({
    padding: `0 ${theme.spacing.medium}`,
    borderRadius: theme.spacing.medium,
    border: "1px solid transparent",
    boxShadow: theme.elevation[theme.colorMode].skim.boxShadow,
    background: theme.colors[theme.colorMode].background_Primary,
}));

export const OrderIdText = styled(Text)(({ theme }) => ({
    marginBottom: theme.spacing.medium,
}));

export const BillDetailsWrapper = styled.div({
    position: "relative",
    zIndex: 2,
});

export const AddTip = styled.div(() => ({
    display: "flex",
}));

export const AddIcon = styled.div(({ theme }) => ({
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: theme.spacing.medium,
    height: theme.spacing.medium,
    flexShrink: 0,
}));

export const TipChevronIcon = styled(AddIcon)<{ $isExpanded: boolean }>(({ $isExpanded }) => ({
    transform: $isExpanded ? "rotate(180deg)" : "rotate(0deg)",
    transition: "transform 0.2s ease",
}));

export const AddText = styled.div(({ theme }) => ({
    display: "flex",
    alignItems: "center",
    marginLeft: theme.spacing.xxSmall,
}));

export const TipAmountRow = styled.div(({ theme }) => ({
    display: "flex",
    alignItems: "center",
    gap: theme.spacing.xSmall,
    flexShrink: 0,
}));

export const TipSuggestion = styled.div(({ theme }) => ({
    display: "flex",
    marginTop: theme.spacing.xSmall,
    justifyContent: "space-between",
}));

export const TipSection = styled.div(({ theme }) => ({
    paddingTop: theme.spacing.small,
    paddingBottom: theme.spacing.small,
}));

interface TipSuggestionItemProps {
    tabIndex: number;
    selectedTipIndex: number;
    theme: DefaultTheme;
}

const TIP_ITEM_WIDTH = "22.4%";
const TIP_ITEM_HEIGHT = 30;
const TIP_ITEM_MARGIN = 6;
const TIP_ITEM_BORDER_RADIUS = 10;

export const TipSuggestionitem = styled.div<TipSuggestionItemProps>(({ tabIndex, selectedTipIndex, theme }) => ({
    width: TIP_ITEM_WIDTH,
    height: TIP_ITEM_HEIGHT,
    margin: `${TIP_ITEM_MARGIN}px ${tabIndex === 3 ? 0 : TIP_ITEM_MARGIN}px`,
    padding: "10px 0",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    borderRadius: TIP_ITEM_BORDER_RADIUS,
    boxShadow: "0px 2px 6px rgba(0, 0, 0, 0.08)",
    border: `1px solid ${
        selectedTipIndex === tabIndex
            ? theme.colors[theme.colorMode].primary
            : theme.colors[theme.colorMode].border_Secondary
    }`,
    backgroundColor: selectedTipIndex === tabIndex ? theme.colors[theme.colorMode].primary_Sub : "transparent",
}));

export const TipElement = styled.div(({ theme }) => ({
    display: "flex",
    justifyContent: "space-between",
    gap: theme.spacing.empty,
}));

export const TipTextWrapper = styled.div({
    display: "flex",
    flexDirection: "column",
});

export const ChargeBottomSheet = styled.div(({ theme }) => ({
    padding: theme.spacing.large,
    backgroundColor: theme.colors[theme.colorMode].background_Primary,
}));
export const TipContainer = styled.div(() => ({
    zIndex: 999,
}));
